// AddToCartPage.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { addToCart } from '../utils/cart';
import { getPublicationByKey } from '../services/api';

const MAX_PUBLICATIONS_PER_ADD = 10;

function AddToCartPage() {
    const { id: rawKeys } = useParams();
    const [error, setError] = useState('');
    const [keyCount, setKeyCount] = useState(1);

    useEffect(() => {
        async function resolveAndAdd() {
            const keys = [...new Set(
                (rawKeys || '')
                    .split(',')
                    .map((key) => key.trim())
                    .filter(Boolean)
            )];
            setKeyCount(keys.length);
            if (keys.length === 0) {
                setError('No publication keys were provided.');
                return;
            }
            if (keys.length > MAX_PUBLICATIONS_PER_ADD) {
                setError(
                    `A maximum of ${MAX_PUBLICATIONS_PER_ADD} publications can be added at once. ` +
                    `This link contains ${keys.length} unique keys.`
                );
                return;
            }

            try {
                const results = await Promise.allSettled(
                    keys.map((key) => getPublicationByKey(key))
                );
                const publications = results
                    .filter((result) => result.status === 'fulfilled')
                    .map((result) => result.value);
                const failedKeys = keys.filter(
                    (_, index) => results[index].status === 'rejected'
                );

                publications.forEach((publication) => addToCart(publication.id));
                const hasOpener = window.opener && !window.opener.closed;
                if (hasOpener) {
                    window.opener.postMessage({
                        type: 'dvkg-added',
                        pubIds: publications.map((publication) => publication.id),
                        pubKeys: publications.map((publication) => publication.key),
                    }, '*');
                }

                if (failedKeys.length > 0) {
                    const prefix = publications.length > 0
                        ? `Added ${publications.length} publication(s). `
                        : '';
                    setError(`${prefix}Publication key(s) not found: ${failedKeys.join(', ')}`);
                    return;
                }
                if (hasOpener) {
                    window.close();
                } else {
                    window.location.replace('/papers');
                }
            } catch (err) {
                setError(err.message);
            }
        }
        resolveAndAdd();
    }, [rawKeys]);

    return (
        <div style={{ textAlign: 'center', marginTop: '20vh' }}>
            {error
                ? <p style={{ color: 'red' }}>{error}</p>
                : <p>Adding {keyCount} publication{keyCount === 1 ? '' : 's'} to cart...</p>
            }
        </div>
    );
}

export default AddToCartPage;
